import {
  INPUT_TYPE,
  validateRepeated,
} from '@components/dragableTableFrom/formItems';
import { DEFALUT_PERMISSION_SECTION } from '@model';
import { FORM_KEYS } from './form.keys';
import { deepCopy } from '@utils/common';

export const INPUT_MAP = {
  [FORM_KEYS.MODULE.key]: {
    inputType: INPUT_TYPE.INPUT,
    // rules: [validateSpaceAndEnter(FORM_KEYS.MODULE.label)],
    maxLength: 20,
    placeholder: FORM_KEYS.MODULE.placeholder,
    // disabled: true,
    rules: [
      validateRepeated(
        FORM_KEYS.MODULE.key,
        'Module Name is required!',
        'Duplicate module name(s)',
      ),
    ],
  },
  // [FORM_KEYS.DISPLAY.key]: {
  //   inputType: INPUT_TYPE.CHECK_BOX,
  // },
  [FORM_KEYS.TYPE.key]: {
    inputType: INPUT_TYPE.PURE_TEXT,
  },
  [FORM_KEYS.IFRAME.key]: {
    inputType: INPUT_TYPE.CHECK_BOX,
  },

  [FORM_KEYS.ICON.key]: {
    inputType: INPUT_TYPE.ICON_SELECTOR,
    rules: [{ required: true, message: 'Icon is required!' }],
  },

  [FORM_KEYS.LINK.key]: {
    // inputType: INPUT_TYPE.INPUT,
    inputType: INPUT_TYPE.TEXT,
    placeholder: FORM_KEYS.LINK.placeholder,
    rules: [{ required: true, message: 'Link is required!' }],
  },
  [FORM_KEYS.MSECTION.key]: {
    inputType: INPUT_TYPE.MAIN_SECTION,
    // placeholder: FORM_KEYS.LINK.placeholder,
    // rules: [{ required: true, message: 'Link is required!' }],
  },
  [FORM_KEYS.SECTION_LIST.key]: {
    inputType: INPUT_TYPE.SECTION_LIST,
    // placeholder: FORM_KEYS.LINK.placeholder,
    rules: [
      {
        validator(_, value) {
          if (Array.isArray(value) && value.some((i) => !i.label)) {
            return Promise.reject('Module Name is required!');
          }
          return Promise.resolve();
        },
        validateTrigger: 'none',
      },
    ],
  },
  [FORM_KEYS.DLINK.key]: {
    inputType: INPUT_TYPE.INPUT,
    disabled: true,
    placeholder: FORM_KEYS.DLINK.placeholder,
  },
  [FORM_KEYS.INTERNAL.key]: {
    inputType: INPUT_TYPE.INTERNAL_BOX,
  },
  [FORM_KEYS.GROUP.key]: {
    inputType: INPUT_TYPE.GROUP_BOX,
  },
  [FORM_KEYS.CLIENT.key]: {
    inputType: INPUT_TYPE.CLIENT_BOX,
  },
  // [FORM_KEYS.CUSTOMIZEPER.key]: {
  //   inputType: INPUT_TYPE.CUSTOMIZE_PERMISSION_BOX,
  // },
  [FORM_KEYS.DELETE.key]: {
    inputType: INPUT_TYPE.DELETE,
    alertContent: 'Are you sure you want to delete this module?',
  },
  [FORM_KEYS.DRAG.key]: {
    inputType: INPUT_TYPE.DRAG,
  },
  [FORM_KEYS.RATIO.key]: {
    inputType: INPUT_TYPE.PURE_SELECT,
    optionKey: FORM_KEYS.RATIO.key,
    // shouldUpdate: (prev, cur) => prev.iframe !== cur.iframe,
  },
};

export const INITIAL_FORM_DATA = [
  {
    [FORM_KEYS.MODULE.key]: 'Project List',
    // [FORM_KEYS.DISPLAY.key]: true,
    [FORM_KEYS.ICON.key]: 'icon-list-view-fill',
    [FORM_KEYS.IFRAME.key]: false,
    [FORM_KEYS.LINK.key]: 'project/home',
    [FORM_KEYS.CLIENT.key]: [{ label: 'Project List', value: 'projectList' }],
    [FORM_KEYS.INTERNAL.key]: [{ label: 'Project List', value: 'projectList' }],
    type: 'default',
    value: DEFALUT_PERMISSION_SECTION.PEOJECT_LIST,
  },
  {
    [FORM_KEYS.MODULE.key]: 'Project Home',
    // [FORM_KEYS.DISPLAY.key]: true,
    [FORM_KEYS.ICON.key]: 'icon-home-fill',
    [FORM_KEYS.IFRAME.key]: false,
    [FORM_KEYS.LINK.key]: 'project-detail',
    [FORM_KEYS.CLIENT.key]: [{ label: 'Project Home', value: 'Home' }],
    [FORM_KEYS.INTERNAL.key]: [{ label: 'Project Home', value: 'Home' }],
    type: 'default',
    value: DEFALUT_PERMISSION_SECTION.HOME,
  },
  {
    [FORM_KEYS.MODULE.key]: 'Questionnaire',
    // [FORM_KEYS.DISPLAY.key]: true,
    [FORM_KEYS.ICON.key]: 'icon-help-question-fill',
    [FORM_KEYS.IFRAME.key]: false,
    [FORM_KEYS.LINK.key]: 'questionnaires',
    [FORM_KEYS.CLIENT.key]: [],
    [FORM_KEYS.INTERNAL.key]: [],
    type: 'default',
    value: DEFALUT_PERMISSION_SECTION.QUESTIONNAIRE,
  },
  {
    [FORM_KEYS.MODULE.key]: 'Side x Side Analysis',
    // [FORM_KEYS.DISPLAY.key]: true,
    [FORM_KEYS.ICON.key]: 'icon-bar-chart-fill',
    [FORM_KEYS.IFRAME.key]: false,
    [FORM_KEYS.LINK.key]: 'analysis',
    [FORM_KEYS.CLIENT.key]: [],
    [FORM_KEYS.INTERNAL.key]: [],
    type: 'default',
    value: DEFALUT_PERMISSION_SECTION.ANALYSIS,
  },
  {
    [FORM_KEYS.MODULE.key]: 'IMO Launch',
    // [FORM_KEYS.DISPLAY.key]: true,
    [FORM_KEYS.ICON.key]: 'icon-spark-line-outline',
    [FORM_KEYS.IFRAME.key]: false,
    [FORM_KEYS.LINK.key]: 'insights',
    [FORM_KEYS.CLIENT.key]: [],
    [FORM_KEYS.INTERNAL.key]: [],
    type: 'default',
    value: DEFALUT_PERMISSION_SECTION.INSIGHT,
  },
  {
    [FORM_KEYS.MODULE.key]: 'Status Reporting',
    // [FORM_KEYS.DISPLAY.key]: true,
    [FORM_KEYS.ICON.key]: 'speedometer',
    [FORM_KEYS.IFRAME.key]: true,
    [FORM_KEYS.LINK.key]:
      'https://app.powerbi.com/groups/c548592a-b8c7-4bd5-8698-f25de5ba80a4/reports/2ba7046b-2c23-4dcb-944f-00d007799149/ReportSection1b49d7d0e5e0731eda2e',
    [FORM_KEYS.CLIENT.key]: [],
    [FORM_KEYS.INTERNAL.key]: [],
    type: 'powerbiModule',
    value: DEFALUT_PERMISSION_SECTION.STATUS_REPORTING,
  },
  {
    [FORM_KEYS.MODULE.key]: 'Synergy Tracker',
    // [FORM_KEYS.DISPLAY.key]: true,
    [FORM_KEYS.ICON.key]: 'touchscreen',
    [FORM_KEYS.IFRAME.key]: true,
    [FORM_KEYS.LINK.key]:
      'https://app.powerbi.com/groups/c548592a-b8c7-4bd5-8698-f25de5ba80a4/reports/03145f3f-6edd-44cc-8443-61e96301993c/ReportSection60de5be6f37a9a8a60a2',
    [FORM_KEYS.CLIENT.key]: [],
    [FORM_KEYS.INTERNAL.key]: [],
    type: 'powerbiModule',
    value: DEFALUT_PERMISSION_SECTION.SYNERGY_TRACKER,
  },
  {
    [FORM_KEYS.MODULE.key]: 'TSA Accelerator',
    // [FORM_KEYS.DISPLAY.key]: true,
    [FORM_KEYS.ICON.key]: 'survey',
    [FORM_KEYS.IFRAME.key]: false,
    [FORM_KEYS.LINK.key]: 'https://magateway.pwc.com/tsa/overview/78',
    [FORM_KEYS.CLIENT.key]: [],
    [FORM_KEYS.INTERNAL.key]: [],
    type: 'regular',
    value: DEFALUT_PERMISSION_SECTION.TSA_ACCELERATOR,
  },
  {
    [FORM_KEYS.MODULE.key]: 'Workforce Architect',
    // [FORM_KEYS.DISPLAY.key]: true,
    [FORM_KEYS.ICON.key]: 'engagement',
    [FORM_KEYS.IFRAME.key]: false,
    [FORM_KEYS.LINK.key]:
      'https://techdatasolutions.pwc.com/workforce_architect_demo/login',
    [FORM_KEYS.CLIENT.key]: [],
    [FORM_KEYS.INTERNAL.key]: [],
    type: 'regular',
    value: DEFALUT_PERMISSION_SECTION.WORKFORCE_ARCHITECT,
  },
];

const modifyFormDataForSellSide = function () {
  return deepCopy(INITIAL_FORM_DATA).filter((i) => {
    if (i.value === DEFALUT_PERMISSION_SECTION.INSIGHT) {
      i[FORM_KEYS.MODULE.key] = 'SMO Launch';
    }
    return i.value !== DEFALUT_PERMISSION_SECTION.SYNERGY_TRACKER;
  });
};

export const INITIAL_FORM_DATA_SELL_SIDE = modifyFormDataForSellSide();
